import Item from './Item';
import { withI18n } from 'react-i18next';

export default withI18n()(Item);
